import React from 'react';
import ResponsiveHeader from './components/ResponsiveHeader';
import Footer from './components/sections/Footer';
import { CITY_PAGES } from './data/cities';

const cityName = (c) => c.name;

const CitiesPage = () => {
  const cities = Object.values(CITY_PAGES)
    .filter((c) => !c.hideFromCityIndex)
    .map((c) => ({ name: cityName(c), path: c.path }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <>
      <ResponsiveHeader title="LOWKEY" useAbsoluteLinkPaths={true} />
      <main className="pt-16 text-white">
        <div className="mx-auto max-w-3xl px-8 pt-12 text-center">
          <h1 className="font-syne-bold text-4xl">Lowkey by City</h1>
          <p className="pt-5 font-space-grotesk-regular text-gray-400">
            Lowkey works with apartment and condo buzzers in cities across North America. Find your city to see how
            it works with the entry panels in your area, or check your buzzer compatibility in 30 seconds.
          </p>
        </div>
        <div className="mx-auto max-w-3xl px-8 py-10">
          <ul className="grid grid-cols-2 gap-4 font-space-grotesk-regular sm:grid-cols-3">
            {cities.map((c) => (
              <li key={c.path}>
                <a href={c.path} className="text-green-lowkey underline">
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
          <p className="pt-10 text-center text-gray-400">
            Not sure Lowkey works with your building?{' '}
            <a className="text-green-lowkey underline" href="/blog/tools/will-lowkey-work-with-my-buzzer/">
              Check your buzzer compatibility
            </a>
            .
          </p>
        </div>
        <Footer />
      </main>
    </>
  );
};

export default CitiesPage;
